export default function ItemList({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col gap-[16px] px-2 ${className ?? ""}`}
      style={{
        paddingBottom: "calc(16px + var(--safe-area-bottom))",
      }}
    >
      {children}
    </div>
  );
}
